import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../Common/Alert";
import DatatableFunc from "../../Common/DatatableFunc";
import Http from "../../Common/Http";
// import { LoaderComponent } from "../../Common/LoaderComponent";
import Swal from "sweetalert2";
import IsLogin from "../../Common/IsLogin";
import ReactDataTable from "../../Common/ReactDataTable";

const List = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(true);
  const { firstDay, lastDay } = getCurrentMonthDateRange();
  const [inputs, setInputs] = useState({
    start_date: firstDay,
    end_date: lastDay,
  });

  function getCurrentMonthDateRange() {
    const dateObj = new Date();
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth();

    // First day of the current month
    const firstDay = `${year}-${String(month + 1).padStart(2, "0")}-01`;

    // Last day of the current month
    const lastDay = `${year}-${String(month + 1).padStart(2, "0")}-${new Date(
      year,
      month + 1,
      0
    ).getDate()}`;

    return { firstDay, lastDay };
  }

  const formSubmit = async () => {
    setLoading(true);
    const submissionInputs = { ...inputs };
    const queryParams = new URLSearchParams({
      start_date: submissionInputs.start_date,
      end_date: submissionInputs.end_date
    });

    try {
      const response = await Http.get(
        `/user-usages-activity-log?${queryParams.toString()}`
      );
      setReceiveData(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error("Error on form submit:", error);
      setLoading(false);
    }
  };

  const fetchData = async () => {
    setLoading(true); // Start loading

    try {
      const res = await Http.get(`/user-usages-activity-log`);
      setReceiveData(res.data.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false); // Stop loading regardless of the outcome
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs((prev) => ({ ...prev, [name]: value }));

    // Ensure the selected date falls within the current month range
    // if (
    //   new Date(value) >= new Date(firstDay) &&
    //   new Date(value) <= new Date(lastDay)
    // ) {
    //   setInputs((prev) => ({ ...prev, [name]: value }));
    // } else {
    //   console.error("Selected date is out of range for the current month.");
    // }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);
  const cols = [
    {
      // field: "department_name",
      header: "Department Name",
      field: "department_name",
      
    },
    {
      // field: "department_name",
      header: "Entries",
      field: (rowData) => (
        <span className={rowData?.no_activity ? "text-danger" : ""}>
          {rowData?.no_activity ? "No Entries" : ""}
        </span>
      ),
    },
    { field: "spr_sent", header: "SPR Send" },
    { field: "mrr_with_qc", header: "MRR with QC" },
    { field: "department_requisition_sent", header: "Dept. Requisition Send" },
    { field: "department_requisition_received", header: "Dept. Requisition Received" },
    { field: "sr_sent", header: "S/R Send" },
    { field: "sr_received", header: "S/R Received" },
    { field: "issue_sent", header: "Issue Send" },
    { field: "issue_received", header: "Issue Received" },
    { field: "ball_charge_body", header: "Ball mill Charged" },
    { field: "filter_cake_production", header: "Body Produced" },
    { field: "production", header: "Production" },
    { field: "fg_transfer_sent", header: "Transfer Send" },
    { field: "fg_transfer_received", header: "Transfer Received" },
    { field: "loss", header: "Loss" },
  ];


  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Units</h5>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
            <div className="am-pagebody">
            <div className="card pd-sm-40">
              <div className="row">
                <div className="col-lg">
                  <label htmlFor="">From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="start_date"
                    value={inputs.start_date}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg">
                  <label htmlFor="">To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="end_date"
                    value={inputs.end_date}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg mt-4">
                  <button
                    className="btn btn-primary btn-block mg-b-10"
                    onClick={formSubmit}
                  >
                    <i className="fa fa-send mg-r-10"></i> Search
                  </button>
                </div>
              </div>
            </div>
          </div>
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default List;
